"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.noConflict = exports.version = exports.Watermark = exports.Badge = exports.Empty = exports.message = exports.Tooltip = exports.WaterMark = exports.Viewer = exports.Import = exports.Picker = exports.ImportUser = exports.UserPicker = exports.MediaUploader = exports.FileUploader = exports.ImageUploader = exports.Uploader = exports.CascadeTree = exports.Tree = exports.SelectTree = exports.TopNav = exports.TimeRoutineSelector = exports.TimePicker = exports.Task = exports.TabCommon = exports.TabPanel = exports.Tabs = exports.Column = exports.Table = exports.Switch = exports.Slider = exports.Select = exports.Rating = exports.RadioGroup = exports.Radio = exports.Portal = exports.OverlayTrigger = exports.Popover = exports.PopOver = exports.PageBar = exports.Menu = exports.Loading = exports.Labels = exports.KeyDay = exports.Input = exports.Icon = exports.FormGroup = exports.Echarts = exports.DropMenuTrigger = exports.DropMenu = exports.DropdownContent = exports.DropdownToggle = exports.Dropdown = exports.Dialog = exports.DatePicker = exports.Collapse = exports.Coder = exports.Clipper = exports.CheckboxGroup = exports.Checkbox = exports.Chart = exports.Carousel = exports.ButtonGroup = exports.Button = exports.BlockSelector = exports.AutoComplete = exports.Alert = exports.Space = exports.Transition = exports.Drawer = exports.Breadcrumb = exports.List = void 0;

var _info = _interopRequireDefault(require("./info"));

var _spauiList = _interopRequireDefault(require("@tencent/spaui-list"));

var _spauiBreadcrumb = _interopRequireDefault(require("@tencent/spaui-breadcrumb"));

var _spauiDrawer = _interopRequireDefault(require("@tencent/spaui-drawer"));

var _odAnimate = _interopRequireDefault(require("@tencent/od-animate"));

var _spauiSpace = _interopRequireDefault(require("@tencent/spaui-space"));

var _spauiAlert = _interopRequireDefault(require("@tencent/spaui-alert"));

var _spauiAutocomplete = _interopRequireDefault(require("@tencent/spaui-autocomplete"));

var _spauiBlockselector = _interopRequireDefault(require("@tencent/spaui-blockselector"));

var _spauiButton = _interopRequireDefault(require("@tencent/spaui-button"));

var _spauiButtongroup = _interopRequireDefault(require("@tencent/spaui-buttongroup"));

var _spauiCarousel = _interopRequireDefault(require("@tencent/spaui-carousel"));

var _spauiChart = _interopRequireDefault(require("@tencent/spaui-chart"));

var _spauiCheckbox = _interopRequireDefault(require("@tencent/spaui-checkbox"));

var _spauiCheckboxgroup = _interopRequireDefault(require("@tencent/spaui-checkboxgroup"));

var _spauiClipper = _interopRequireDefault(require("@tencent/spaui-clipper"));

var _spauiCoder = _interopRequireDefault(require("@tencent/spaui-coder"));

var _spauiCollapse = _interopRequireDefault(require("@tencent/spaui-collapse"));

var _spauiDatepicker = _interopRequireDefault(require("@tencent/spaui-datepicker"));

var _spauiDialog = _interopRequireDefault(require("@tencent/spaui-dialog"));

var _spauiDropdown = _interopRequireDefault(require("@tencent/spaui-dropdown"));

var _spauiDropmenu = _interopRequireDefault(require("@tencent/spaui-dropmenu"));

var _spauiEcharts = _interopRequireDefault(require("@tencent/spaui-echarts"));

var _spauiFormgroup = _interopRequireDefault(require("@tencent/spaui-formgroup"));

var _spauiIcon = _interopRequireDefault(require("@tencent/spaui-icon"));

var _spauiInput = _interopRequireDefault(require("@tencent/spaui-input"));

var _spauiKeyday = _interopRequireDefault(require("@tencent/spaui-keyday"));

var _spauiLabels = _interopRequireDefault(require("@tencent/spaui-labels"));

var _spauiLoading = _interopRequireDefault(require("@tencent/spaui-loading"));

var _spauiMenu = _interopRequireDefault(require("@tencent/spaui-menu"));

var _spauiPagebar = _interopRequireDefault(require("@tencent/spaui-pagebar"));

var _spauiPopover = _interopRequireDefault(require("@tencent/spaui-popover"));

var _spauiPortal = _interopRequireDefault(require("@tencent/spaui-portal"));

var _spauiRadio = _interopRequireDefault(require("@tencent/spaui-radio"));

var _spauiRadiogroup = _interopRequireDefault(require("@tencent/spaui-radiogroup"));

var _spauiRating = _interopRequireDefault(require("@tencent/spaui-rating"));

var _spauiSelect = _interopRequireDefault(require("@tencent/spaui-select"));

var _spauiSlider = _interopRequireDefault(require("@tencent/spaui-slider"));

var _spauiSwitch = _interopRequireDefault(require("@tencent/spaui-switch"));

var _spauiTable = _interopRequireDefault(require("@tencent/spaui-table"));

var _spauiTabs = _interopRequireDefault(require("@tencent/spaui-tabs"));

var _spauiTask = _interopRequireDefault(require("@tencent/spaui-task"));

var _spauiTimepicker = _interopRequireDefault(require("@tencent/spaui-timepicker"));

var _spauiTimeroutineselector = _interopRequireDefault(require("@tencent/spaui-timeroutineselector"));

var _spauiTopnav = _interopRequireDefault(require("@tencent/spaui-topnav"));

var _spauiSelectTree = _interopRequireDefault(require("@tencent/spaui-select-tree"));

var _spauiTree = _interopRequireDefault(require("@tencent/spaui-tree"));

var _spauiUploader = _interopRequireDefault(require("@tencent/spaui-uploader"));

var _spauiUserpicker = _interopRequireDefault(require("@tencent/spaui-userpicker"));

var _spauiViewer = _interopRequireDefault(require("@tencent/spaui-viewer"));

var _spauiWatermark = _interopRequireDefault(require("@tencent/spaui-watermark"));

var _spauiTooltip = _interopRequireDefault(require("@tencent/spaui-tooltip"));

var _spauiMessage = _interopRequireDefault(require("@tencent/spaui-message"));

var _spauiEmpty = _interopRequireDefault(require("@tencent/spaui-empty"));

var _spauiBadge = _interopRequireDefault(require("@tencent/spaui-badge"));

var _spauiUtils = require("@tencent/spaui-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// 获取页面全局变量的函数
var getWindowVariable = function getWindowVariable() {
  var varName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var varData = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && varName ? window[varName] : '';
  var result = null;

  if (_typeof(varData) === 'object' && varData && typeof varData["default"] !== 'undefined') {
    result = window[varName]["default"];
  }

  return result;
};

var exportTemp = null;

var List = getWindowVariable('SPAUI_LIST') || _spauiList["default"];

exports.List = List;

var Breadcrumb = getWindowVariable('SPAUI_BREADCRUMB') || _spauiBreadcrumb["default"];

exports.Breadcrumb = Breadcrumb;

var Drawer = getWindowVariable('SPAUI_DRAWER') || _spauiDrawer["default"];

exports.Drawer = Drawer;

/**
 * @deprecated 请使用 rc-motion 的 CSSMotion 代替
 */
var Transition = getWindowVariable('SPAUI_TRANSITION') || _odAnimate["default"];

exports.Transition = Transition;

var Space = getWindowVariable('SPAUI_SPACE') || _spauiSpace["default"];

exports.Space = Space;

var Alert = getWindowVariable('SPAUI_ALERT') || _spauiAlert["default"];

exports.Alert = Alert;

var AutoComplete = getWindowVariable('SPAUI_AUTOCOMPLETE') || _spauiAutocomplete["default"];

exports.AutoComplete = AutoComplete;

var BlockSelector = getWindowVariable('SPAUI_BLOCKSELECTOR') || _spauiBlockselector["default"];

exports.BlockSelector = BlockSelector;

var Button = getWindowVariable('SPAUI_BUTTON') || _spauiButton["default"];

exports.Button = Button;

var ButtonGroup = getWindowVariable('SPAUI_BUTTONGROUP') || _spauiButtongroup["default"];

exports.ButtonGroup = ButtonGroup;

var Carousel = getWindowVariable('SPAUI_CAROUSEL') || _spauiCarousel["default"];

exports.Carousel = Carousel;

var Chart = getWindowVariable('SPAUI_CHART') || _spauiChart["default"];

exports.Chart = Chart;

var Checkbox = getWindowVariable('SPAUI_CHECKBOX') || _spauiCheckbox["default"];

exports.Checkbox = Checkbox;

var CheckboxGroup = getWindowVariable('SPAUI_CHECKBOXGROUP') || _spauiCheckboxgroup["default"];

exports.CheckboxGroup = CheckboxGroup;

var Clipper = getWindowVariable('SPAUI_CLIPPER') || _spauiClipper["default"];

exports.Clipper = Clipper;

var Coder = getWindowVariable('SPAUI_CODER') || _spauiCoder["default"];

exports.Coder = Coder;

var Collapse = getWindowVariable('SPAUI_COLLAPSE') || _spauiCollapse["default"];

exports.Collapse = Collapse;

var DatePicker = getWindowVariable('SPAUI_DATEPICKER') || _spauiDatepicker["default"];

exports.DatePicker = DatePicker;

var Dialog = getWindowVariable('SPAUI_DIALOG') || _spauiDialog["default"];

exports.Dialog = Dialog;

var SPAUI_DROPDOWN = getWindowVariable('SPAUI_DROPDOWN') || _spauiDropdown["default"];

exportTemp = SPAUI_DROPDOWN.Dropdown;
exportTemp.Dropdown = SPAUI_DROPDOWN.Dropdown;
exportTemp.DropdownToggle = SPAUI_DROPDOWN.DropdownToggle;
exportTemp.DropdownContent = SPAUI_DROPDOWN.DropdownContent;
var Dropdown = exportTemp;
exports.Dropdown = Dropdown;
var DropdownToggle = SPAUI_DROPDOWN.DropdownToggle;
exports.DropdownToggle = DropdownToggle;
var DropdownContent = SPAUI_DROPDOWN.DropdownContent;
exports.DropdownContent = DropdownContent;

var SPAUI_DROPMENU = getWindowVariable('SPAUI_DROPMENU') || _spauiDropmenu["default"];

exportTemp = SPAUI_DROPMENU.DropMenu;
exportTemp.DropMenu = SPAUI_DROPMENU.DropMenu;
exportTemp.DropMenuTrigger = SPAUI_DROPMENU.DropMenuTrigger;
var DropMenu = exportTemp;
exports.DropMenu = DropMenu;
var DropMenuTrigger = SPAUI_DROPMENU.DropMenuTrigger;
exports.DropMenuTrigger = DropMenuTrigger;

var Echarts = getWindowVariable('SPAUI_ECHARTS') || _spauiEcharts["default"];

exports.Echarts = Echarts;

var FormGroup = getWindowVariable('SPAUI_FORMGROUP') || _spauiFormgroup["default"];

exports.FormGroup = FormGroup;

var Icon = getWindowVariable('SPAUI_ICON') || _spauiIcon["default"];

exports.Icon = Icon;

var Input = getWindowVariable('SPAUI_INPUT') || _spauiInput["default"];

exports.Input = Input;

var KeyDay = getWindowVariable('SPAUI_KEYDAY') || _spauiKeyday["default"];

exports.KeyDay = KeyDay;

var Labels = getWindowVariable('SPAUI_LABELS') || _spauiLabels["default"];

exports.Labels = Labels;

var Loading = getWindowVariable('SPAUI_LOADING') || _spauiLoading["default"];

exports.Loading = Loading;

var Menu = getWindowVariable('SPAUI_MENU') || _spauiMenu["default"];

exports.Menu = Menu;

var PageBar = getWindowVariable('SPAUI_PAGEBAR') || _spauiPagebar["default"];

exports.PageBar = PageBar;

var SPAUI_POPOVER = getWindowVariable('SPAUI_POPOVER') || _spauiPopover["default"];

exportTemp = SPAUI_POPOVER.PopOver;
exportTemp.PopOver = SPAUI_POPOVER.PopOver;
exportTemp.Popover = SPAUI_POPOVER.PopOver;
exportTemp.OverlayTrigger = SPAUI_POPOVER.OverlayTrigger;
var PopOver = exportTemp;
exports.PopOver = PopOver;
var Popover = exportTemp;
exports.Popover = Popover;
var OverlayTrigger = SPAUI_POPOVER.OverlayTrigger;
exports.OverlayTrigger = OverlayTrigger;

var Portal = getWindowVariable('SPAUI_PORTAL') || _spauiPortal["default"];

exports.Portal = Portal;

var Radio = getWindowVariable('SPAUI_RADIO') || _spauiRadio["default"];

exports.Radio = Radio;

var RadioGroup = getWindowVariable('SPAUI_RADIOGROUP') || _spauiRadiogroup["default"];

exports.RadioGroup = RadioGroup;

var Rating = getWindowVariable('SPAUI_RATING') || _spauiRating["default"];

exports.Rating = Rating;

var Select = getWindowVariable('SPAUI_SELECT') || _spauiSelect["default"];

exports.Select = Select;

var Slider = getWindowVariable('SPAUI_SLIDER') || _spauiSlider["default"];

exports.Slider = Slider;

var Switch = getWindowVariable('SPAUI_SWITCH') || _spauiSwitch["default"];

exports.Switch = Switch;

var SPAUI_TABLE = getWindowVariable('SPAUI_TABLE') || _spauiTable["default"];

exportTemp = SPAUI_TABLE.Table;
exportTemp.Table = SPAUI_TABLE.Table;
exportTemp.Column = SPAUI_TABLE.Column;
var Table = exportTemp;
exports.Table = Table;
var Column = SPAUI_TABLE.Column;
exports.Column = Column;

var SPAUI_TABS = getWindowVariable('SPAUI_TABS') || _spauiTabs["default"];

exportTemp = SPAUI_TABS.Tabs;
exportTemp.Tabs = SPAUI_TABS.Tabs;
exportTemp.TabPanel = SPAUI_TABS.TabPanel;
exportTemp.TabCommon = SPAUI_TABS.TabCommon;
var Tabs = exportTemp;
exports.Tabs = Tabs;
var TabPanel = SPAUI_TABS.TabPanel;
exports.TabPanel = TabPanel;
var TabCommon = SPAUI_TABS.TabCommon;
exports.TabCommon = TabCommon;

var Task = getWindowVariable('SPAUI_TASK') || _spauiTask["default"];

exports.Task = Task;

var TimePicker = getWindowVariable('SPAUI_TIMEPICKER') || _spauiTimepicker["default"];

exports.TimePicker = TimePicker;

var TimeRoutineSelector = getWindowVariable('SPAUI_TIMEROUTINESELECTOR') || _spauiTimeroutineselector["default"];

exports.TimeRoutineSelector = TimeRoutineSelector;

var TopNav = getWindowVariable('SPAUI_TOPNAV') || _spauiTopnav["default"];

exports.TopNav = TopNav;

var SelectTree = getWindowVariable('SPAUI_SELECT_TREE') || _spauiSelectTree["default"];

exports.SelectTree = SelectTree;

var SPAUI_TREE = getWindowVariable('SPAUI_TREE') || _spauiTree["default"];

exportTemp = SPAUI_TREE.Tree;
exportTemp.Tree = SPAUI_TREE.Tree;
exportTemp.CascadeTree = SPAUI_TREE.CascadeTree;
var Tree = exportTemp;
exports.Tree = Tree;
var CascadeTree = SPAUI_TREE.CascadeTree;
exports.CascadeTree = CascadeTree;

var SPAUI_UPLOADER = getWindowVariable('SPAUI_UPLOADER') || _spauiUploader["default"];

exportTemp = SPAUI_UPLOADER.Uploader;
exportTemp.Uploader = SPAUI_UPLOADER.Uploader;
exportTemp.ImageUploader = SPAUI_UPLOADER.ImageUploader;
exportTemp.FileUploader = SPAUI_UPLOADER.FileUploader;
exportTemp.MediaUploader = SPAUI_UPLOADER.MediaUploader;
var Uploader = exportTemp;
exports.Uploader = Uploader;
var ImageUploader = SPAUI_UPLOADER.ImageUploader;
exports.ImageUploader = ImageUploader;
var FileUploader = SPAUI_UPLOADER.FileUploader;
exports.FileUploader = FileUploader;
var MediaUploader = SPAUI_UPLOADER.MediaUploader;
exports.MediaUploader = MediaUploader;

var SPAUI_USERPICKER = getWindowVariable('SPAUI_USERPICKER') || _spauiUserpicker["default"];

exportTemp = SPAUI_USERPICKER.UserPicker;
exportTemp.UserPicker = SPAUI_USERPICKER.UserPicker;
exportTemp.ImportUser = SPAUI_USERPICKER.ImportUser;
exportTemp.Picker = SPAUI_USERPICKER.Picker;
exportTemp.Import = SPAUI_USERPICKER.Import;
var UserPicker = exportTemp;
exports.UserPicker = UserPicker;
var ImportUser = SPAUI_USERPICKER.ImportUser;
exports.ImportUser = ImportUser;
var Picker = SPAUI_USERPICKER.Picker;
exports.Picker = Picker;
var Import = SPAUI_USERPICKER.Import;
exports.Import = Import;

var Viewer = getWindowVariable('SPAUI_VIEWER') || _spauiViewer["default"];

exports.Viewer = Viewer;

var WaterMark = getWindowVariable('SPAUI_WATERMARK') || _spauiWatermark["default"];

exports.WaterMark = WaterMark;

var Tooltip = getWindowVariable('SPAUI_TOOLTIP') || _spauiTooltip["default"];

exports.Tooltip = Tooltip;

var message = getWindowVariable('SPAUI_MESSAGE') || _spauiMessage["default"];

exports.message = message;

var Empty = getWindowVariable('SPAUI_EMPTY') || _spauiEmpty["default"];

exports.Empty = Empty;

var Badge = getWindowVariable('SPAUI_BADGE') || _spauiBadge["default"]; // WaterMark名称调整为Watermark


exports.Badge = Badge;
var Watermark = WaterMark;
exports.Watermark = Watermark;
var componentUsageReporting = _spauiUtils.report.componentUsageReporting,
    cancelComponentSignReport = _spauiUtils.report.cancelComponentSignReport;
typeof cancelComponentSignReport !== 'undefined' && cancelComponentSignReport();
typeof componentUsageReporting !== 'undefined' && componentUsageReporting({
  scope: 'spaui',
  name: 'spaui',
  version: _info["default"].version
});
typeof componentUsageReporting !== 'undefined' && componentUsageReporting({
  scope: 'spaui',
  name: 'react',
  version: window.React ? window.React.version : '0'
});
var version = _info["default"].version;
exports.version = version;
var OLD_SPAUI = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window && window.SPAUI;

var noConflict = function noConflict() {
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window && window.SPAUI) {
    window.SPAUI = OLD_SPAUI;
  }

  return {
    List: List,
    Breadcrumb: Breadcrumb,
    Drawer: Drawer,
    Transition: Transition,
    Alert: Alert,
    Space: Space,
    Tooltip: Tooltip,
    message: message,
    Empty: Empty,
    Badge: Badge,
    AutoComplete: AutoComplete,
    BlockSelector: BlockSelector,
    Button: Button,
    ButtonGroup: ButtonGroup,
    Carousel: Carousel,
    Chart: Chart,
    Checkbox: Checkbox,
    CheckboxGroup: CheckboxGroup,
    Clipper: Clipper,
    Coder: Coder,
    Collapse: Collapse,
    DatePicker: DatePicker,
    Dialog: Dialog,
    Dropdown: Dropdown,
    DropdownToggle: DropdownToggle,
    DropdownContent: DropdownContent,
    DropMenu: DropMenu,
    DropMenuTrigger: DropMenuTrigger,
    Echarts: Echarts,
    FormGroup: FormGroup,
    Icon: Icon,
    Input: Input,
    KeyDay: KeyDay,
    Labels: Labels,
    Loading: Loading,
    Menu: Menu,
    PageBar: PageBar,
    PopOver: PopOver,
    Popover: Popover,
    OverlayTrigger: OverlayTrigger,
    Portal: Portal,
    Radio: Radio,
    RadioGroup: RadioGroup,
    Rating: Rating,
    Select: Select,
    Slider: Slider,
    Switch: Switch,
    Table: Table,
    Column: Column,
    Tabs: Tabs,
    TabPanel: TabPanel,
    TabCommon: TabCommon,
    Task: Task,
    TimePicker: TimePicker,
    TimeRoutineSelector: TimeRoutineSelector,
    TopNav: TopNav,
    Tree: Tree,
    CascadeTree: CascadeTree,
    Uploader: Uploader,
    ImageUploader: ImageUploader,
    FileUploader: FileUploader,
    MediaUploader: MediaUploader,
    UserPicker: UserPicker,
    ImportUser: ImportUser,
    Picker: Picker,
    Import: Import,
    Viewer: Viewer,
    WaterMark: WaterMark,
    version: version,
    Watermark: Watermark,
    SelectTree: SelectTree
  };
};

exports.noConflict = noConflict;
var _default = {
  List: List,
  Breadcrumb: Breadcrumb,
  Drawer: Drawer,
  Alert: Alert,
  Space: Space,
  Transition: Transition,
  Tooltip: Tooltip,
  message: message,
  Empty: Empty,
  Badge: Badge,
  AutoComplete: AutoComplete,
  BlockSelector: BlockSelector,
  Button: Button,
  ButtonGroup: ButtonGroup,
  Carousel: Carousel,
  Chart: Chart,
  Checkbox: Checkbox,
  CheckboxGroup: CheckboxGroup,
  Clipper: Clipper,
  Coder: Coder,
  Collapse: Collapse,
  DatePicker: DatePicker,
  Dialog: Dialog,
  Dropdown: Dropdown,
  DropdownToggle: DropdownToggle,
  DropdownContent: DropdownContent,
  DropMenu: DropMenu,
  DropMenuTrigger: DropMenuTrigger,
  Echarts: Echarts,
  FormGroup: FormGroup,
  Icon: Icon,
  Input: Input,
  KeyDay: KeyDay,
  Labels: Labels,
  Loading: Loading,
  Menu: Menu,
  PageBar: PageBar,
  PopOver: PopOver,
  Popover: Popover,
  OverlayTrigger: OverlayTrigger,
  Portal: Portal,
  Radio: Radio,
  RadioGroup: RadioGroup,
  Rating: Rating,
  Select: Select,
  Slider: Slider,
  Switch: Switch,
  Table: Table,
  Column: Column,
  Tabs: Tabs,
  TabPanel: TabPanel,
  TabCommon: TabCommon,
  Task: Task,
  TimePicker: TimePicker,
  TimeRoutineSelector: TimeRoutineSelector,
  TopNav: TopNav,
  Tree: Tree,
  CascadeTree: CascadeTree,
  Uploader: Uploader,
  ImageUploader: ImageUploader,
  FileUploader: FileUploader,
  MediaUploader: MediaUploader,
  UserPicker: UserPicker,
  ImportUser: ImportUser,
  Picker: Picker,
  Import: Import,
  Viewer: Viewer,
  WaterMark: WaterMark,
  version: version,
  Watermark: Watermark,
  noConflict: noConflict,
  SelectTree: SelectTree
};
exports["default"] = _default;